/**
 * Note Updates entity class
 */

/**
 * NoteUpdatesFactory
 * returns NoteUpdates entity class
 *
 * @class NoteUpdatesFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.NoteUpdates} class
 *
 * @ngdoc factory
 * @name mwApp.factory:NoteUpdatesFactory
 */

/* @ngInject */
export default function NoteUpdatesFactory (Entity, Note) {
  /* === NoteUpdates class === */

  /**
   * NoteUpdates model
   *
   * @class NoteUpdates
   * @classdesc NoteUpdates model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @return {models.NoteUpdates} NoteUpdates entity
   */
  function NoteUpdates () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  NoteUpdates.prototype = Object.create(Entity.prototype)
  NoteUpdates.prototype.constructor = NoteUpdates

  /* === NoteUpdates instance methods & fields === */

  Object.assign(NoteUpdates.prototype, {

    /**
     * instance fields
     *
     * @memberof models.NoteUpdates#
     * @type {Object}
     */
    _fields: {
      updatedTime: String,
      updatedBy: String,
      diff: {
        description: {
          before: String,
          after: String
        },
        subject: {
          before: String,
          after: String
        },
        issueObject: {
          before: String,
          after: String
        },
        type: {
          before: String,
          after: String
        }
      }
    },

    /**
     * url template
     *
     * @memberof models.NoteUpdates#
     * @type {String}
     */
    _urlTemplate: 'api/subscribers/{{subscriberId}}/notes/{{noteId}}/snapshots',

    /**
     * public url template
     *
     * @memberof models.NoteUpdates#
     * @type {String}
     */
    _publicUrlTemplate: 'subscribers/{{subscriber.id}}/NoteUpdatess/{{::id}}',

    _prepare: function () {
      for (const beforeAfter of ['before', 'after']) {
        const string = this.diff.description[beforeAfter]
        if (string) {
          this.diff.description[beforeAfter] = Note.insertImgIntoDiv(string)
        }
      }
    }

  })

  /* === NoteUpdates static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(NoteUpdates, Entity)
  NoteUpdates._name = 'NoteUpdates'
  NoteUpdates.init()

  // permissions
  NoteUpdates.access = {
  }

  return NoteUpdates
}
